<script lang="ts">
  import { components } from "@component/factory";
  import type { Component } from "svelte";
  import ErrorComponent from "./errorComponent.svelte";

  let { rendering } = $props();
  let { componentName, ...fields } = $derived(rendering);
  let ComponentTag: Component = $derived(components[componentName]);
</script>

{#if ComponentTag}
  <ComponentTag {...fields} />
{:else}
  <ErrorComponent {rendering} />
{/if}
